<template>
  <canvas id="effects" ref="canvas"></canvas>
</template>

<script>
export default {
  name: "DustParticles",

  mounted() {
    this.createParticles();
    this.createFlickerArea();
    this.animate();
  },
  data() {
    return {
      flickerPoints: [
        { x: 1324, y: 436 },
        { x: 1331, y: 426 },
        { x: 1389, y: 430 },
        { x: 1396, y: 434 },
        { x: 1398, y: 447 },
        { x: 1398, y: 516 },
        { x: 1387, y: 524 },
        { x: 1331, y: 517 },
        { x: 1321, y: 502 },
        { x: 1320, y: 451 },
      ],
      animationFrameId: null,
    };
  },
  methods: {
    createParticles() {
      // Initialisiere den Canvas und die Partikel
      this.canvas = this.$refs.canvas;
      this.ctx = this.canvas.getContext("2d");
      this.canvas.width = 1920; //TODO _X
      this.canvas.height = 1080;

      this.particles = [];
      for (let i = 0; i < 700; i++) {
        this.particles.push(this.newParticle());
      }
    },

    newParticle() {
      return {
        x: Math.random() * this.canvas.width,
        y: Math.random() * this.canvas.height,
        size: this.particleSize(),
        velocityX: Math.random() * 0.2 - 0.1,
        velocityY: Math.random() * 0.2 - 0.1,
        opacity: Math.random() * 0.25, // Start with random opacity
        fadingOut: Math.random() >= 0.5, // Randomly decide if fading out or in
        fadeRate: Math.random() * 0.0008 + 0.0001, // Random fade rate
      };
    },
    particleSize() {
      let zufallszahl = Math.random();
      if (zufallszahl < 0.6) {
        // 50% Wahrscheinlichkeit, eine Zahl zwischen 1 und 5 zu generieren
        return Math.floor((zufallszahl * 10) / 3) + 3;
      } else if (zufallszahl < 0.94) {
        // 30% Wahrscheinlichkeit, eine Zahl zwischen 6 und 11 zu generieren
        return Math.floor(((zufallszahl - 0.7) * 10) / 0.3) + 6;
      } else if (zufallszahl < 0.985) {
        // 15% Wahrscheinlichkeit, eine Zahl zwischen 12 und 20 zu generieren
        return Math.floor(((zufallszahl - 0.9) * 20) / 0.15) + 12;
      } else {
        // 5% Wahrscheinlichkeit, eine Zahl zwischen 21 und 40 zu generieren
        return Math.floor(((zufallszahl - 0.95) * 40) / 0.05) + 21;
      }
    },
    updateParticle(particle) {
      particle.x += particle.velocityX;
      particle.y += particle.velocityY;
      

      // Überprüfen und Zurücksetzen der Partikel am Rand des Canvas
      if (particle.x < 0) {
        particle.x = this.canvas.width;
      } else if (particle.x > this.canvas.width) {
        particle.x = 0;
      }

      if (particle.y < 0) {
        particle.y = this.canvas.height;
      } else if (particle.y > this.canvas.height) {
        particle.y = 0;
      }
      if (particle.fadingOut) {
        particle.opacity -= particle.fadeRate;
        if (particle.opacity <= 0) {
          particle.opacity = 0;
          particle.fadingOut = false;
        }
      } else {
        particle.opacity += particle.fadeRate;
        if (particle.opacity >= 0.25) {
          particle.opacity = 0.25;
          particle.fadingOut = true;
        }
      }
    },

    drawParticle(particle) {
      this.ctx.beginPath();
      //  this.ctx.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2);
      let grd = this.ctx.createRadialGradient(
        particle.x,
        particle.y,
        Math.ceil(particle.size * 0.2),
        particle.x,
        particle.y,
        Math.ceil(particle.size * 0.8)
      );
      //let color
      //let grd
      this.drawCustomPolygon();

      if (
        this.ctx.isPointInPath(particle.x, particle.y) &&
        particle.size < 16
      ) {
        let opacity = particle.opacity + 0.4;
        opacity = opacity > 1 ? 1 : opacity;
        //grd = `rgba(242, 242, 242, ${opacity})`;
        grd.addColorStop(0, `rgba(255, 255, 255, ${opacity})`);
        grd.addColorStop(1, `rgba(242, 242, 242,0`);
      } else {
        //color = `rgba(217, 217, 217, ${particle.opacity})`;
        grd.addColorStop(0, `rgba(242, 242, 242, ${particle.opacity})`);
        grd.addColorStop(1, `rgba(217, 217, 217, 0`);
      }
      this.ctx.beginPath();
      this.ctx.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2);
      this.ctx.fillStyle = grd;
      this.ctx.fill();
    },
    createFlickerArea() {
      // Berechne die Grenzen des Polygons
      this.flickerMinX = Math.min(...this.flickerPoints.map((p) => p.x));
      this.flickerMaxX = Math.max(...this.flickerPoints.map((p) => p.x));
      this.flickerMinY = Math.min(...this.flickerPoints.map((p) => p.y));
      this.flickerMaxY = Math.max(...this.flickerPoints.map((p) => p.y));
    },
    drawTV() {
      this.ctx.save();
      this.ctx.beginPath();
      this.ctx.moveTo(this.flickerPoints[0].x, this.flickerPoints[0].y);
      this.flickerPoints.forEach((p) => this.ctx.lineTo(p.x, p.y));
      this.ctx.closePath();
      this.ctx.clip();

      // Fülle das Polygon mit Flimmern
      for (let y = this.flickerMinY; y < this.flickerMaxY; y++) {
        for (let x = this.flickerMinX; x < this.flickerMaxX; x++) {
          if (this.ctx.isPointInPath(x, y)) {
            this.ctx.fillStyle = Math.random() < 0.5 ? "white" : "black";
            this.ctx.fillRect(x, y, 1, 1);
          }
        }
      }

      // Stelle den vorherigen Zustand wieder her, um die Partikel zu zeichnen
      this.ctx.restore();
    },
    drawCustomPolygon() {
      this.ctx.beginPath();
      this.ctx.moveTo(1351.15, 547);
      this.ctx.lineTo(1048.21, 180);
      this.ctx.lineTo(888.21, 180);
      this.ctx.lineTo(555.21, 547);
      this.ctx.bezierCurveTo(589.45, 576.96, 740.93, 701.88, 967.21, 697);
      this.ctx.bezierCurveTo(1177.15, 692.48, 1315.41, 579.18, 1352.15, 547);
      this.ctx.closePath();
    },
    drawTVLight() {
      var radius = 200;
      var opacity = Math.random() * 0.2 + 0.18; // Schnelles, leichtes Flackern
      var gradient = this.ctx.createRadialGradient(
        1357,
        478,
        radius - 80,
        1357,
        478,
        radius
      );
      gradient.addColorStop(0, "rgba(230, 247, 255, " + opacity + ")");
      gradient.addColorStop(1, "rgba(230, 247, 255, 0)");
      this.ctx.fillStyle = gradient;
      this.ctx.beginPath();
      this.ctx.arc(1357, 478, radius, 0, 2 * Math.PI);
      this.ctx.fill();
    },
    drawLight() {
      const lightX = 950; // Zentrum des Lichts
      const lightY = 200; // Zentrum des Lichts
      const innerRadius = 200;
      const outerRadius = 500; // Stärkerer Verlauf

      const gradient = this.ctx.createRadialGradient(
        lightX,
        lightY,
        innerRadius,
        lightX,
        lightY,
        outerRadius
      );
      gradient.addColorStop(0, "rgba(245,245,220, 0.3)");
      gradient.addColorStop(1, "rgba(245,245,220, 0)");

      this.ctx.fillStyle = gradient;
      this.ctx.fill();
    },
    drawMainLight() {
      // Schwarzen Hintergrund setzen
      this.drawCustomPolygon();
      // Flackerndes Licht
      if (Math.random() > 0.01) {
        this.drawLight();
      }
    },
    animate() {
      //this.ctx.globalCompositeOperation = 'lighter';
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.drawTV();
      this.particles.forEach((particle) => {
        this.updateParticle(particle);
        this.drawParticle(particle);
      });
      this.drawTVLight();
      this.drawMainLight();
      
      this.animationFrameId = requestAnimationFrame(this.animate);
    },
    stopAnimation() {
      cancelAnimationFrame(this.animationFrameId);
    },
  },

  beforeDestroy() {
    // Stoppe die Animation, wenn die Komponente zerstört wird
    this.stopAnimation();
  },
};
</script>

<style scoped>
#effects {
  border: 1px solid black;
  width: 1920px;
  position: absolute;
  height: 1080px;
  top: 0;
  z-index: 10;
  pointer-events: none;
}
</style>
